"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react');

var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);




const EMPTY = {
  NoReply: false, NoReplyMessage: '', Keywords: [], Welcome: true, StopLineOn: true, StopLineText: '',
}

// Loads a team's reply settings by key, and saves no-reply mode, keywords
// and the welcome switch through UpdateTeam; each save sends only its own
// fields. Whether no-reply is on comes from the team in the store
// (Team.NoReply); until the load succeeds, settings are EMPTY and callers
// keep their controls locked.
const useTeamReplySettings = (teamKey) => {
  const [settings, setSettings] = _react.useState(EMPTY)
  const [loadState, setLoadState] = _react.useState('loading')

  const load = _react.useCallback.call(void 0, 
    () => _actions2.default.getTeamReplySettings({ TeamKey: teamKey })
      .then(({ ReplySettings }) => {
        // A team with no keywords can come back with a null list.
        setSettings({ ...EMPTY, ...ReplySettings, Keywords: _nullishCoalesce(ReplySettings.Keywords, () => ( [])) })
        setLoadState('loaded')
      }),
    [teamKey],
  )

  _react.useEffect.call(void 0, () => {
    setSettings(EMPTY)
    setLoadState('loading')
    load().catch(() => setLoadState('failed'))
  }, [load])

  // A save is the outcome; a failed reload afterwards only leaves what was
  // shown, and locks the controls.
  const reload = _react.useCallback.call(void 0, () => load().catch(() => setLoadState('failed')), [load])

  const saveNoReply = _react.useCallback.call(void 0, 
    (isOn, message) => _actions2.default.updateTeam({
      TeamKey: teamKey,
      NoReply: isOn,
      NoReplyMessage: message,
    }).then(reload),
    [teamKey, reload],
  )

  // Replaces the team's whole keyword list.
  const saveKeywords = _react.useCallback.call(void 0, 
    (keywords) => _actions2.default.updateTeam({ TeamKey: teamKey, Keywords: keywords }).then(reload),
    [teamKey, reload],
  )

  const saveWelcome = _react.useCallback.call(void 0, 
    (isOn) => _actions2.default.updateTeam({ TeamKey: teamKey, Welcome: isOn }).then(reload),
    [teamKey, reload],
  )

  return {
    settings,
    isLoaded: loadState === 'loaded',
    loadFailed: loadState === 'failed',
    saveNoReply,
    saveKeywords,
    saveWelcome,
  }
}

exports. default = useTeamReplySettings
